import { render, staticRenderFns } from "./DetalhesLote.vue?vue&type=template&id=7a8c20aa"
import script from "./DetalhesLote.vue?vue&type=script&lang=js"
export * from "./DetalhesLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports